import { setElementInert, trapElement } from '../../util/a11y/handle-inert';
import { forceSmoothScrollTo } from '../../util/helpers';

export default {
  init() {
    const hero = document.querySelector('.ms-product-detail-hero');

    if (hero) {
      // A11Y fix for Voice-over to read custom-styled list as "lists" - WR-785.
      const isSafari = Boolean(window.navigator.userAgent.match(/Version\/[\d.]+.*Safari/));

      // For Safari Only.
      if (isSafari) {
        const formattedDesc = hero.querySelector('.ms-product-detail-hero__formatted-desc');
        const listContents = formattedDesc.getElementsByTagName('ul');

        if (listContents.length) {
          Array.from(listContents).forEach(listElem => {
            listElem.setAttribute('role', 'list');

            Array.from(listElem.children).forEach(listItem => {
              listItem.setAttribute('role', 'listitem');
            });
          });
        }
      }

      this.startListener(hero);
    }
  },
  startListener(hero) {
    const html = document.querySelector('html');
    const modal = hero.querySelector('.ms-nutritional-modal');
    const modalToggle = hero.querySelector('.ms-product-detail-hero__nutritional-info');
    const modalWrapper = hero.querySelector('.ms-product-detail-hero__wrapper');
    const previewFigures = hero.querySelectorAll('.ms-product-detail-hero__preview-figure');
    const scrollerTrack = hero.querySelector('.ms-nutritional-modal__scroller-track');
    const thumbnails = hero.querySelector('.ms-product-detail-hero__thumbs');
    const scrollDownCaret = hero.querySelector('.ms-product-detail-hero__caret-lg');
    const thumbs = thumbnails.querySelectorAll('.ms-product-detail-hero__thumb');
    const modalCloseButton = document.getElementById('modal-close-button');
    const modalOpenButton = document.getElementById('modal-open-button');

    const changeView = ({ target }) => {
      const { classList, dataset } = target;
      const { select } = dataset;

      Array.prototype.find.call(previewFigures, ({ classList }) => classList.contains('active')).classList.remove('active');
      const prevActive = Array.prototype.find.call(thumbs, ({ classList }) => classList.contains('active'));
      prevActive.classList.remove('active');
      prevActive.setAttribute('aria-pressed', false);

      classList.add('active');
      target.setAttribute('aria-pressed', true);
      previewFigures[select].classList.add('active');
    }

    const handleClickOutside = ({ target }) => {
      const insideWrapper = target === modalWrapper || target.closest('.ms-nutritional-modal__wrapper');
      const insideScrolelrTrack = target === scrollerTrack || target.closest('.ms-nutritional-modal__scroller-track');

      if (!insideWrapper && !insideScrolelrTrack) {
        closeModal();
      }
    }

    let untrapModal = () => {}
    setElementInert(true, modal);

    const toggleModal = () => {
      const lists = [...Array.from(modal.querySelectorAll('ol')), ...Array.from(modal.querySelectorAll('ul'))];

      if (modal.classList.contains('active')) {
        closeModal();

        // Reset list roles.
        lists.forEach(list => {
          list.removeAttribute('role');
          list.querySelectorAll('li').forEach(li => {
            li.removeAttribute('role');
          });
        });
      } else {
        html.classList.add('modal-on');
        modal.classList.add('active');
        modalToggle.classList.add('active');
        thumbnails.classList.add('modal-on');

        untrapModal = trapElement(modal);

        // get fist element to focus
        let firstFocus = modal.querySelector('.ms-nutritional-modal__heading');

        firstFocus.setAttribute('aria-label', '');
        firstFocus.setAttribute('tabindex', '-1');

        // on mobile, the text is not focusable so we opted to use the close button instead
        setTimeout(() => {
          // Mobile Safari specific
          if (/iPhone|iPod|iPad/.test(navigator.platform)) {
            modalCloseButton.focus();
          } else {
            firstFocus.focus();
            firstFocus.removeAttribute('tabindex');
          }

          // Manually add list roles for macOS voice-over issues with reading list elements.
          lists.forEach(list => {
            list.setAttribute('role', 'list');
            list.querySelectorAll('li').forEach(li => {
              li.setAttribute('role', 'listitem');
            });
          });
        }, 600);
      }
    }

    const closeModal = () => {
      modal.classList.remove('active');
      html.classList.remove('modal-on');
      modalToggle.classList.remove('active');
      thumbnails.classList.remove('modal-on');

      untrapModal();
      setElementInert(true, modal);

      // Set the focus back to modal open button.
      modalOpenButton.focus();
    }

    modal.addEventListener('click', handleClickOutside);
    modalCloseButton.addEventListener('click', () => {
      closeModal();
    });

    if (!hero.nextElementSibling) {
      scrollDownCaret.style.display = 'none';
    }

    const svgCaretButton = scrollDownCaret.children[0];

    svgCaretButton.addEventListener('click', () => {
      const nextModuleSibling = hero.nextElementSibling;

      // Scroll to the next module.
      if (nextModuleSibling && nextModuleSibling.classList.contains('ms-module')) {
        const navigationElement = document.querySelector('.ms-navigation');
        const scrollToValue = nextModuleSibling.offsetTop;
        const scrollOffset = navigationElement.offsetHeight;

        forceSmoothScrollTo(scrollToValue - scrollOffset);
      }
    });

    document.addEventListener('keydown', (e) => {
      // Close the modal using ESC button.
      if (e.keyCode === 27 && modal.classList.contains('active')) {
        closeModal();
      }
    });

    if (modalToggle) {
      modalToggle.addEventListener('click', toggleModal);
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click' , changeView);
    });
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/product-detail-hero.js